import { userConstants } from "../../../../constants/Public/user.constants";

const initialState = {
    fetching :false,
    resetPasswordStatus: false,
    resetPasswordData: [],
    error    :{},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case userConstants.RESET_PASSWORD_PENDING:
            return {
                fetching : false,
                resetPasswordStatus:false,
                error:{},
            };
        case userConstants.RESET_PASSWORD_FULFILLED:
            return {
                ...state,
                fetching : false,
                resetPasswordStatus : true,
                resetPasswordData: action.payload,
            };
        case userConstants.RESET_PASSWORD_REJECTED:
            return {
                ...state,
                fetching : false,
                resetPasswordStatus:false,
                error: action.payload
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            }
        default:
            return state
    }
}
